import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service'
import {BalanceComponent} from "./components/balance.component";

const balanceRoutes = [{
                path: 'balance',
                component: BalanceComponent,
                canActivate:[CanActivateViaAuthGuard]}];

@NgModule({
  imports: [RouterModule.forChild(balanceRoutes)],
  exports: [RouterModule],
  providers: []
})
export class BalanceRoutingModule { }
